import { useGetUnreadAnnouncementCountQuery } from '../api/endpoints/announcements';

/**
 * Menü kartları için badge (bildirim sayısı) verilerini döndürür.
 * Her kartın id'si ile eşleşen sayıyı map olarak sağlar.
 * Yeni badge eklemek için buraya yeni bir query eklemek yeterlidir.
 */
const useMenuBadges = () => {
    const { data: unreadAnnouncementCount = 0 } = useGetUnreadAnnouncementCountQuery();

    // id → sayı map'i
    const badges = {
        announcements: unreadAnnouncementCount
    };

    const getBadge = (categoryId) => badges[categoryId] ?? 0;

    return { badges, getBadge };
};

export default useMenuBadges;